import {LayoutIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 38"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      stroke: "#fff",
      "stroke-width": ".3",
      d: "M43.55.903 43.445.78l-.115.113-28.337 28.088-10.21-10.693-.112-.117-.109.12L.89 22.356l-.094.103.097.101 13.886 14.544.106.11.108-.108L47.108 5.275l.099-.098-.09-.106z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(LayoutIcon, {icon: {render}, name: "check_white"}) } }